import { Block } from "@xprog/prensa";
import ArticleComponent from "components/Base/Base.Article";
import SearchEngine from "components/SearchEngine/SearchEngine.index";
import SectionMore from "components/SectionMore";
import SectionTitle from "components/SectionTitle";
import React from "react";

// import AdsComponent from "../Ads/Ads.index";
import RenderBlocks from "./Base.Blocks";
import RenderComponent from "./Base.Component";
import RenderSideMenu from "./Base.SideMenu";
import RenderTeaser from "./Base.Teaser";
import RenderTopbar from "./Base.Topbar";
import { useContext } from "react";
import { SessionDataContext } from "providers/Session";
import { useKeycloak } from "@react-keycloak/ssr";
import { KeycloakInstance } from "keycloak-js";


export const ComponentSwitch: any = ({ data, pageBlockId }) => {
  const isDesktop = data?.customProps?.className?.includes("desktop");
  const isDeviceDesktop = window.innerWidth > 980;
  switch (data?.type) {
    // AdsComponent desativado em pro da implementação nova de Ads.Slot.{SITE}
    // case "com.atex.standard.component.AdsBean":
    //   return <AdsComponent {...data} isDesktop={isDesktop} />;
    case "com.atex.standard.pageblock.PageblockArticleBean":
      if (isDesktop) return <></>;
      return <ArticleComponent {...data} />;
    case "com.atex.standard.pageblock.PageblockBean":
      return <RenderBlocks {...data} isDesktop={isDesktop} />;
    case "com.atex.standard.component.FilterBean":
      if (isDesktop) return <></>;
      return <SearchEngine {...data} pageBlockId={pageBlockId} />;
    case "br.com.atex.templates.articleVideo.it":
    case "br.com.atex.templates.pageblockComponent.it":
    case "com.atex.standard.component.ComponentBean":
      if (isDesktop) return <></>;
      return (
        <RenderComponent
          {...data}
          isDesktop={isDesktop}
          pageBlockId={pageBlockId}
        />
      );
    case "com.atex.standard.article.ArticleBean":
    case "com.atex.plugins.teaser.TeaserBean":
      if (isDesktop && isDeviceDesktop) {
        return <RenderTeaser {...data} isDesktop={isDesktop} />;
      } else if (!isDesktop && !isDeviceDesktop) {
        return <RenderTeaser {...data} isDesktop={isDesktop} />;
      }
      break;
    case "com.atex.standard.pageblock.PageblockButtonBean":
      return <SectionMore {...data} isDesktop={isDesktop} />;
    case "com.atex.standard.pageblock.PageblockTitleBean":
      return <SectionTitle {...data} isDesktop={isDesktop} />;
    default:
      return <React.Fragment />;
  }
};

const BaseStructure = ({ children }) => {
  const sessionData = useContext(SessionDataContext);
  const {keycloak} = useKeycloak<KeycloakInstance>()
  return (
    <Block css={{ width: "100%" }}>
      <RenderTopbar />
      {children}
      <RenderSideMenu />
    </Block>
  );
};

export default BaseStructure;
